import { platforms } from '~/constants/platforms'
import type { ISignInResponse } from '~/api/types'

/**
 * Checks if the new 2FA flow is required for this login and sets required data
 * @param response response from weblogin
 * @returns true when 2FA is required
 */
export const twoFactorAuthRequired = async (response: ISignInResponse) => {
  const registerStore = useRegisterStore()

  // 2FA only applies to MT platforms
  if (
    registerStore.platform !== platforms.XEMT &&
    registerStore.platform !== platforms.BRITLINE &&
    registerStore.platform !== platforms.JOHN_LEWIS
  ) {
    return false
  }

  // old flow - FXWeb handles 2FA
  if (response.require2FA === undefined) {
    return false
  }

  if (response.require2FA) {
    const twoFactorAuthStore = useTwoFactorAuthStore()
    if (response.twoFactorAuthStatus) {
      twoFactorAuthStore.setTwoFactorAuthStatus(response.twoFactorAuthStatus)
    }
    twoFactorAuthStore.setRequired(true)
    twoFactorAuthStore.setUseWebLogin(true)
    twoFactorAuthStore.setVerificationChannels(response.verificationChannels)
    registerStore.setAccountType(
      response.customerProfile?.accountType === 'Corporate' ? 'Business' : 'Personal'
    )

    const phoneNumber = response.customerProfile?.twoFANumber?.number
    if (phoneNumber) {
      twoFactorAuthStore.setPhoneNumber(response.customerProfile.twoFANumber.number)

      if (response.twoFactorAuthStatus === 'SetupRequired') {
        await twoFactorAuthStore.lookupPhoneNumber(response.customerProfile.twoFANumber.number)
      } else if (response.twoFactorAuthStatus === 'Required') {
        twoFactorAuthStore.setPhoneNumberType(response.customerProfile.twoFANumber.phoneNumberType)
      }
    }
    twoFactorAuthStore.setPreviousChannel(response.codeSentType)
    return true
  }

  return false
}
